import * as types from '../actiontypes';

export function getProjectsByEngagement(url, engagementId, userId) {
	url = url + '/projects?engagementId=' + engagementId;
	return {
		type: types.GET_OVERSIGHT_PROJECTS_BY_ENGAGEMENT,
		meta: {
			api: {
				url: url,
				method: 'GET',
				headers: {CallerApp: 'can'}
			}
		},
		engagementId: engagementId,
		userId: userId
	};
}

export function getOtherProjectsByEngagement(url, engagementId) {
	url = url + '/projects?engagementId=' + engagementId + '&includeOtherProjects=true';
	return {
		type: types.GET_OVERSIGHT_OTHER_PROJECTS_BY_ENGAGEMENT,
		meta: {
			api: {
				url: url,
				method: 'GET',
				headers: {CallerApp: 'can'},
				engagementId: engagementId
			}
		}
	};
}

export function createGroupProject(url, data, payload) {
	url = url + '/projects';
	return {
		type: types.CREATE_GROUP_OVERSIGHT_PROJECT,
		meta: {
			api: {
				url: url,
				method: 'POST',
				headers: {CallerApp: 'can'},
				data: data
			}
		},
		payload
	};
}